import * as Lucide from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface IconProps {
  name?: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
  title?: string;
}

/**
 * Maps the prototype's kebab-case Lucide names to lucide-react's
 * PascalCase exports. Same API as the prototype's <Ic/> helper.
 */
export function Icon({ name, size = 16, strokeWidth = 1.5, className, title }: IconProps) {
  if (!name) return null;
  const key = toPascal(name);
  const Comp = (Lucide as unknown as Record<string, LucideIcon | undefined>)[key];
  if (!Comp) {
    if (typeof window !== 'undefined' && import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn(`[Icon] unknown lucide-react icon "${name}" (looked up "${key}")`);
    }
    return null;
  }
  return (
    <Comp
      size={size}
      strokeWidth={strokeWidth}
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
      className={className}
    >
      {title ? <title>{title}</title> : null}
    </Comp>
  );
}

function toPascal(name: string): string {
  return name
    .split('-')
    .filter(Boolean)
    .map((s) => s[0]!.toUpperCase() + s.slice(1))
    .join('');
}
